/**
 * Raiz dos arquivos do chat (anexos, avatares, emojis), no layout do CDN do
 * Discord. Igual ao `CHAT_FILES_URL` da API: relativo, mesma origem.
 */
export const ARQUIVOS = import.meta.env.VITE_ARQUIVOS_URL ?? '/api/chat/anexos';
